import React from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import theme from "./assets/styles/theme";

const withTheme = children => (
    <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
);

export default withTheme;
